module.exports = __webpack_public_path__ + "static/media/sponsor.c09e23aa.png";